import { render } from "./HintButton.vue?vue&type=template&id=4c755b0a&scoped=true"
import script from "./HintButton.vue?vue&type=script&lang=js"
export * from "./HintButton.vue?vue&type=script&lang=js"

import "./HintButton.vue?vue&type=style&index=0&id=4c755b0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c755b0a"]])

export default __exports__